// extracted by mini-css-extract-plugin
module.exports = {"main":"Nft_detail_buy_main__PE710","main_layout":"Nft_detail_buy_main_layout__NtAio","main_item":"Nft_detail_buy_main_item__qr1hD"};